import { Box, Chip, Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import type { DashboardTalentCommittee } from '@/api/dashboardApi';
import { SectionCard } from '@/components/common';
import { formatDateShort as formatShortDate } from '@/utils/dateFormatter';
import { AppraisalStatusChip } from './AppraisalStatusChip';

function appraisalLabel(firstName: string, lastName: string): string {
  return `Appraisal \u2013 ${firstName} ${lastName}`;
}

interface TalentCommitteeSubsectionProps {
  tc: DashboardTalentCommittee;
}

export function TalentCommitteeSubsection({ tc }: TalentCommitteeSubsectionProps) {
  return (
    <SectionCard>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography component="h3" sx={{ typography: { xs: 'h6', md: 'h5' } }}>
          {tc.tcName}
        </Typography>
        {tc.plannedDate && (
          <Chip label={`TC Date: ${formatShortDate(tc.plannedDate)}`} size="small" variant="outlined" />
        )}
      </Box>
      {tc.appraisees.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No appraisees in this committee.
        </Typography>
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: 'custom.darkTeal', '& th': { color: 'common.white' } }}>
                <TableCell>TALENT COMMITTEE</TableCell>
                <TableCell>ROLE</TableCell>
                <TableCell>STATUS</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tc.appraisees.map((appraisee) => (
                <TableRow key={appraisee.appraisalId}>
                  <TableCell>
                    <Link component={RouterLink} to={`/appraisals/${appraisee.appraisalId}`} underline="hover">
                      {appraisalLabel(appraisee.appraiseeFirstName, appraisee.appraiseeLastName)}
                    </Link>
                  </TableCell>
                  <TableCell>{appraisee.tenureInGrade ?? '-'}</TableCell>
                  <TableCell>
                    <AppraisalStatusChip status={appraisee.status} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </SectionCard>
  );
}

export default TalentCommitteeSubsection;
